module.exports.MemoryStore = require('./memory-store');
module.exports.LocalStorageStore = require('./localstorage-store');